import * as React from "react";
import { forwardRef } from "react";
const SvgScheduled = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 13, viewBox: "0 0 12 13", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 6, cy: 6.30774, r: 4.5, stroke: "#F3A623", strokeWidth: 3, fill: "transparent" }));
const ForwardRef = forwardRef(SvgScheduled);
export default ForwardRef;
